/* 
i pledge that i have neither given nor recieved prohibited aid on this assessment
emma trzupek
02/06/23

note:
only the first album has actual songs, and they're all just 5 second jingles to demonstrate how the code works
*/

import App0 from './App0'
import App1 from './App1'
//imports data from outside file
import stateGlob from './state';
import { useState } from 'react'

const App = () => {
    //state only used for forcing the page to update. sort, for the order the albums are displayed, and button display
    const [ state, setState ] = useState(0);
    const [ sort, setSort ] = useState(0);
    const [ buttonDisplay, setDisplay ] = useState(["none", "block"]);
    const tempStateGlob = stateGlob.state;
    const pageState = () => {
        if(tempStateGlob === stateGlob.state) {
            stateGlob.state = 0;
        }
        setState(state+1);
    }
    //sets the display of the button, and returns the appropriate component
    const changePage = () => {
        if(stateGlob.state === 0) {
            if(buttonDisplay[0] === "block") {
                setDisplay(["none", "block"]);
            }
            //inc is used when the album images are clicked
            return <App0 inc = {pageState} sortOrder = {sort}/>
        } 
        if(buttonDisplay[1] === "block") {
            setDisplay(["block", "none"]);
        }
        return <App1 album = {stateGlob.state}/>
    }
    //doesn't loop back to the default, because that's unsorted
    const changeSort = () => {
        if(sort > 2) {
            setSort(1);
        } else {
            setSort(sort+1);
        }
    }
    //display for the button
    const getSortType = () => {
        if(sort === 0) {
            return "default";
        } else if(sort === 1) {
            return "album name";
        } else if(sort === 2) {
            return "artist name";
        } else if(sort === 3) {
            return "song count";
        }
        return "???";
    }
    return (
        <div>
            {changePage()}
            <button className = "pageChange" onClick = {pageState} style = {{display: buttonDisplay[0]}}>home</button>
            <button className = "sortButton" onClick = {changeSort} style = {{display: buttonDisplay[1]}}>sort by: {getSortType()}</button>
        </div> 
    )
}

export default App